import { useEffect, useState } from 'react';
import Styles from '../../assets/css/common/deleteConfirmation.module.scss';
import { AiOutlineLoading } from 'react-icons/ai';

const DeleteConfirmation = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Delete Product",
    message = "Are you sure you want to delete this product? This action cannot be undone.",
    confirmText = "Delete",
    cancelText = "Cancel",
    isLoading = false
}) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setLoading(false);
        }
    }, [isOpen]);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm();
        } catch (error) {
            console.error('Delete confirmation error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        if (!loading) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div
            className={`${Styles.overlay}`}
            onClick={handleBackdropClick}
            role="dialog"
            aria-modal="true"
            aria-labelledby="delete-confirmation-title"
        >
            <div className={`${Styles.deleteModal}`}>
                <div className={`${Styles.modalHeader}`}>
                    <div className={`${Styles.warningIcon}`}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 9V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <h3 id="delete-confirmation-title" className={`${Styles.modalTitle}`}>
                        {title}
                    </h3>
                    <button
                        className={`${Styles.closeButton}`}
                        onClick={onClose}
                        aria-label="Close dialog"
                        disabled={isLoading}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 4L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                </div>

                <div className={`${Styles.modalBody}`}>
                    <p className={`${Styles.message}`}>{message}</p>
                </div>

                <div className={`${Styles.modalFooter}`}>
                    <button
                        className={`${Styles.cancelButton}`}
                        onClick={handleClose}
                        disabled={loading}
                    >
                        {cancelText}
                    </button>
                    <button
                        className={`${Styles.confirmButton}`}
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? <AiOutlineLoading className={`${Styles.spinner}`} /> : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmation;